<template>
	<div class="final-report-invoices">
		<project-invoices-donation-warning
			style="page-break-inside: avoid"
			v-if="showInvoicesWarning && donation"
			:donation="donation"/>
		<project-invoices-date-mismatch-warning
			style="page-break-inside: avoid"
			:project-start-date="projectStartDate"
			:project-end-date="projectEndDate"
			:terms="terms"
			:invoices="invoices"/>
		<final-report-invoices-warning
			style="page-break-inside: avoid"
			:invoices="invoices"/>
		<project-invoices-multiple-dates-warning
			style="page-break-inside: avoid"
			:invoices="invoices"/>
		<FinalReportHeaderRow
			text="3. Zestawienie dokumentów"
		/>
		<v-layout class="final-report-invoices-header financial-table-header-color" style="page-break-inside: avoid">
			<v-flex xs1 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Lp.
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Rodzaj dokumentu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Numer dokumentu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Wartość całkowita dokumentu <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Data wystawienia
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Data zapłaty
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>

						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout class="final-report-invoices-header financial-table-header-color" style="page-break-inside: avoid">
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text>
						<strong>

						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							Numer pozycji
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs5 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							Nazwa kosztu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z dotacji <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z innych środków finansowych <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z uzyskanych odsetek od dotacji
							lub pozostałych przychodów <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							wkład rzeczowy <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							wkład osobowy <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout style="page-break-inside: avoid">
			<v-flex xs12 d-flex>
				<v-card color='grey darken-2' class="financial-table-header-font-size financial-table-header-color">
					<v-card-text>
						<strong>
							A. Koszty administracyjne
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div v-for="(serial, keyIdx) of Object.keys(administrativeCostsInvoices)" class="final-report-invoices-cost"
			:key="'administrative-serial-' + keyIdx">
			<div v-for="(invoice, invoiceIdx) in administrativeCostsInvoices[serial]" class="final-report-invoices-cost"
				:key="'administrative-' + invoice.documentName + '-' + invoiceIdx">
				<final-report-invoices-invoice-general-data-row
					class="financial-table-header-font-size"
					:index="getAdministrativeCostInvoiceIndex(serial, invoiceIdx)"
					:invoice="invoice"
				/>
				<final-report-invoices-single-cost
					v-for="(cost, costIdx) in invoice.administrative"
					:ref="'invoicesSingleAdministrativeCost-' + serial + '-' + invoiceIdx + '-' + costIdx"
					:key="'single-administrative-cost-' + cost.serialNumber + '-' + costIdx"
					:cost="cost"
				/>
			</div>
			<v-layout style="page-break-inside: avoid">
				<v-flex xs7 d-flex>
					<v-card color='grey' class="financial-table-header-font-size financial-table-header-color">
						<v-card-text>
							<strong>
								Razem wydatki na pozycję
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsSerialInvoices(['z dotacji'], serial))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsSerialInvoices([
									'środki finansowe własne',
									'świadczenie pieniężne od odbiorców',
									'środki finansowe z innych źródeł publicznych',
									'pozostałe'], serial))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsSerialInvoices(['odsetki', 'przychody'], serial))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsSerialInvoices(['wkład rzeczowy'], serial))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsSerialInvoices(['wkład osobowy'], serial))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</div>

		<template>
			<v-layout style="page-break-inside: avoid">
				<v-flex xs7 d-flex>
					<v-card color='grey darken-2' class="financial-table-header-font-size financial-table-header-color">
						<v-card-text>
							<strong>
								Razem A
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsInvoices(['z dotacji']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsInvoices([
									'środki finansowe własne',
									'świadczenie pieniężne od odbiorców',
									'środki finansowe z innych źródeł publicznych',
									'pozostałe']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsInvoices(['odsetki', 'przychody']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsInvoices(['wkład rzeczowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAdministrativeCostsInvoices(['wkład osobowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<v-layout style="page-break-inside: avoid">
			<v-flex xs12 d-flex>
				<v-card color='grey darken-2' class="financial-table-header-font-size financial-table-header-color">
					<v-card-text>
						<strong>
							P. Koszty programowe
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<div v-for="(serialAction, actionKeyIdx) of Object.keys(actionsCostsInvoices)"
			:key="'action-serial-' + actionKeyIdx"
			class="final-report-invoices-cost">
			<div v-for="(serialCost, costKeyIdx) of Object.keys(actionsCostsInvoices[serialAction])"
				class="final-report-invoices-cost"
				:key="'action-cost-serial-' + costKeyIdx">
				<div v-for="(invoice, invoiceIdx) in actionsCostsInvoices[serialAction][serialCost]"
					class="final-report-invoices-cost"
					:key="'administrative-' + invoice.documentName + '-' + invoiceIdx">
					<final-report-invoices-invoice-general-data-row
						class="financial-table-header-font-size"
						:index="getActionCostInvoiceIndex(serialAction, serialCost, invoiceIdx)"
						:invoice="invoice"
					/>
					<div
						v-for="(action, actionIdx) in invoice.actions"
						:key="'action-cost-' + action.serialNumber + '-' + actionIdx"
					>
						<final-report-invoices-single-cost
							:ref="'invoicesSingleActionCost-' + serialAction + '-' + serialCost + '-' + invoiceIdx + '-' + actionIdx + '-' + costIdx"
							v-for="(cost, costIdx) in action.costs"
							:key="'single-action-cost-' + cost.serialNumber + '-' + costIdx"
							:lp-prefix="action.serialNumber"
							:cost="cost"
						/>
					</div>
				</div>
				<v-layout style="page-break-inside: avoid">
					<v-flex xs7 d-flex>
						<v-card color='grey' class="financial-table-header-font-size financial-table-header-color">
							<v-card-text>
								<strong>
									Razem wydatki na pozycję
								</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs1 d-flex>
						<v-card color='grey'>
							<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
								class="financial-table-value-font-size">
								<span>
									{{formatMoney(costOfTypeActionsCostsSerialInvoices(['z dotacji'], serialAction, serialCost))}}
								</span>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs1 d-flex>
						<v-card color='grey'>
							<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
								class="financial-table-value-font-size">
								<span>
									{{formatMoney(costOfTypeActionsCostsSerialInvoices([
										'środki finansowe własne',
										'świadczenie pieniężne od odbiorców',
										'środki finansowe z innych źródeł publicznych',
										'pozostałe'], serialAction, serialCost))}}
								</span>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs1 d-flex>
						<v-card color='grey'>
							<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
								class="financial-table-value-font-size">
								<span>
									{{formatMoney(costOfTypeActionsCostsSerialInvoices(['odsetki', 'przychody'], serialAction, serialCost))}}
								</span>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs1 d-flex>
						<v-card color='grey'>
							<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
								class="financial-table-value-font-size">
								<span>
									{{formatMoney(costOfTypeActionsCostsSerialInvoices(['wkład rzeczowy'], serialAction, serialCost))}}
								</span>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs1 d-flex>
						<v-card color='grey'>
							<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
								class="financial-table-value-font-size">
								<span>
									{{formatMoney(costOfTypeActionsCostsSerialInvoices(['wkład osobowy'], serialAction, serialCost))}}
								</span>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</div>
			<v-layout style="page-break-inside: avoid">
				<v-flex xs7 d-flex>
					<v-card color='grey darken-1' class="financial-table-header-font-size financial-table-header-color">
						<v-card-text>
							<strong>
								Razem wydatki na działanie
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-1'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsSerialInvoices(['z dotacji'], serialAction))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-1'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsSerialInvoices([
									'środki finansowe własne',
									'świadczenie pieniężne od odbiorców',
									'środki finansowe z innych źródeł publicznych',
									'pozostałe'], serialAction))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-1'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsSerialInvoices(['odsetki', 'przychody'], serialAction))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-1'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsSerialInvoices(['wkład rzeczowy'], serialAction))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-1'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsSerialInvoices(['wkład osobowy'], serialAction))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</div>

		<template>
			<v-layout style="page-break-inside: avoid">
				<v-flex xs7 d-flex>
					<v-card color='grey darken-2' class="financial-table-header-font-size financial-table-header-color">
						<v-card-text>
							<strong>
								Razem P
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsCostsInvoices(['z dotacji']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsCostsInvoices([
									'środki finansowe własne',
									'świadczenie pieniężne od odbiorców',
									'środki finansowe z innych źródeł publicznych',
									'pozostałe']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsCostsInvoices(['odsetki', 'przychody']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsCostsInvoices(['wkład rzeczowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeActionsCostsInvoices(['wkład osobowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<template>
			<v-layout style="page-break-inside: avoid">
				<v-flex xs7 d-flex>
					<v-card color='grey darken-2' class="financial-table-header-font-size financial-table-header-color">
						<v-card-text>
							<strong>
								Ogółem
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAllCostsInvoices(['z dotacji']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAllCostsInvoices([
									'środki finansowe własne',
									'świadczenie pieniężne od odbiorców',
									'środki finansowe z innych źródeł publicznych',
									'pozostałe']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAllCostsInvoices(['odsetki', 'przychody']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAllCostsInvoices(['wkład rzeczowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='grey darken-2'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right"
							class="financial-table-value-font-size">
							<span>
								{{formatMoney(costOfTypeAllCostsInvoices(['wkład osobowy']))}}
							</span>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>
	</div>
</template>

<script>
	import {Numbers} from "@/utils/Numbers";
	import {FinalReportInvoicesExporter} from "./Utils/FinalReportInvoicesExporter";
	import FinalReportInvoicesInvoiceGeneralDataRow from "./FinalReportInvoicesInvoiceGeneralDataRow";
	import FinalReportInvoicesSingleCost from "./FinalReportInvoicesSingleCost";
	import FinalReportHeaderRow from "./FinalReportHeaderRow";
	import FinalReportInvoicesWarning from "./FinalReportInvoicesWarning";
	import ProjectInvoicesDonationWarning from "../project/invoices/ProjectInvoicesDonationWarning";
	import ProjectInvoicesDateMismatchWarning from "../project/invoices/ProjectInvoicesDateMismatchWarning";
  import ProjectInvoicesMultipleDatesWarning from "@/view/logged/project/invoices/ProjectInvoicesMultipleDatesWarning";

	export default {
		name: "FinalReportInvoices",
		components: {
      ProjectInvoicesMultipleDatesWarning,
			ProjectInvoicesDateMismatchWarning,
			ProjectInvoicesDonationWarning,
			FinalReportInvoicesWarning,
			FinalReportHeaderRow, FinalReportInvoicesSingleCost, FinalReportInvoicesInvoiceGeneralDataRow
		},
		mixins: [Numbers, FinalReportInvoicesExporter],

		computed: {
			administrativeCostsInvoices () {
				let admInvoices = this.invoices.filter(x => x.administrative.length > 0);
				let mapKeys = new Set();
				admInvoices.forEach(invoice => {
					invoice.administrative.forEach(cost => mapKeys.add(cost.serialNumber));
				});
				let sortedKeys = Array.from(mapKeys).sort();
				let resultDict = {};
				sortedKeys.forEach(key => {
					let clonedInvoices = JSON.parse(JSON.stringify(admInvoices));
					clonedInvoices.forEach(invoice =>
						invoice.administrative = invoice.administrative.filter(cost => cost.serialNumber === key)
					);
					resultDict[key] = clonedInvoices.filter(invoice => invoice.administrative.length > 0);
				});

        sortedKeys.forEach(key => {
          resultDict[key] = resultDict[key].sort(this.compareCosts);
        });

        return resultDict;
			},

			actionsCostsInvoices () {
				let actionInvoices = this.invoices.filter(x => x.actions.length > 0);
				let mapKeys = {};
				actionInvoices.forEach(invoice => {
					invoice.actions.forEach(action => {
						action.costs.forEach(cost => {
							if (!mapKeys[action.serialNumber]) {
								mapKeys[action.serialNumber] = new Set();
							}
							mapKeys[action.serialNumber].add(cost.serialNumber);
						});
					});
				});
				let sortedData = {};
				Object.keys(mapKeys).sort().forEach(actionKey => {
					let costKeys = Array.from(mapKeys[actionKey]).sort();
					costKeys.forEach(costKey => {
						if (!sortedData[actionKey]) sortedData[actionKey] = {};
						sortedData[actionKey][costKey] = JSON.parse(JSON.stringify(actionInvoices));
						sortedData[actionKey][costKey] = sortedData[actionKey][costKey].filter(invoice => {
							invoice.actions = invoice.actions.filter(a => {
								a.costs = a.costs.filter(c => {
									return parseFloat(c.serialNumber) === parseFloat(costKey);
								});
								return parseFloat(a.serialNumber) === parseFloat(actionKey) && a.costs.length > 0;
							});
							return invoice.actions.length > 0;
						});
					});

          costKeys.forEach(costKey => {
            sortedData[actionKey][costKey] = sortedData[actionKey][costKey].sort(this.compareCosts);
          });
				});
				return sortedData;
			},
		},

		methods: {
      compareDateStrings(a, b) {
        let formattedA = a.split('-').reverse().join('-');
        let formattedB = b.split('-').reverse().join('-');

        if (formattedA < formattedB) {
          return 1;
        }
        if (formattedA > formattedB) {
          return -1;
        }
        return 0;
      },

      compareCosts(x, y) {
        let documentDateEarlier = this.compareDateStrings(y.documentDate, x.documentDate);
        if (documentDateEarlier !== 0) {
          return documentDateEarlier;
        }
		if (y.paymentDates[0] && x.paymentDates[0]) {
				let paymentDateEarlier = this.compareDateStrings(y.paymentDates[0], x.paymentDates[0]);
				if (paymentDateEarlier !== 0) {
					return paymentDateEarlier;
				}
			}

        if (y.documentNumber < x.documentNumber) {
          return 1;
        }
        if (y.documentNumber > x.documentNumber) {
          return -1;
        }

        if (y.id < x.id) {
          return 1;
        }
        if (y.id > x.id) {
          return -1;
        }
      },

      getAdministrativeCostInvoiceIndex (serial, invoiceIdx) {
        return FinalReportInvoicesExporter.getAdministrativeCostInvoiceIndex(this, serial, invoiceIdx);
      },

      getActionCostInvoiceIndex (serialAction, serialCost, invoiceIdx) {
        return FinalReportInvoicesExporter.getActionCostInvoiceIndex(this, serialAction, serialCost, invoiceIdx);
      },

			costOfTypeAllCostsInvoices (costTypes) {
				return this.costOfTypeActionsCostsInvoices(costTypes) + this.costOfTypeAdministrativeCostsInvoices(costTypes);
			},

			costOfTypeActionsCostsInvoices (costTypes) {
				let result = 0;
				for (let key1 of Object.keys(this.actionsCostsInvoices)) {
					for (let key2 of Object.keys(this.actionsCostsInvoices[key1])) {
						for (let invoice of this.actionsCostsInvoices[key1][key2]) {
							result += this.costOfTypeAction(costTypes, invoice.actions);
						}
					}
				}
				return result;
			},

			costOfTypeAdministrativeCostsInvoices (costTypes) {
				let result = 0;
				for (let invoice of this.invoices.filter(x => x.administrative.length > 0)) {
					result += this.costOfType(costTypes, invoice.administrative);
				}
				return result;
			},

			costOfTypeAdministrativeCostsSerialInvoices (costTypes, serial) {
				let result = 0;
				for (let invoice of this.administrativeCostsInvoices[serial]) {
					result += this.costOfType(costTypes, invoice.administrative);
				}
				return result;
			},

			costOfTypeActionsCostsSerialInvoices (costTypes, serialAction, serialCost) {
				let result = 0;
				for (let invoice of this.actionsCostsInvoices[serialAction][serialCost]) {
					result += this.costOfTypeAction(costTypes, invoice.actions);
				}
				return result;
			},

			costOfTypeActionsSerialInvoices (costTypes, serialAction) {
				let result = 0;
				for (let key of Object.keys(this.actionsCostsInvoices[serialAction])) {
					for (let invoice of this.actionsCostsInvoices[serialAction][key]) {
						result += this.costOfTypeAction(costTypes, invoice.actions);
					}
				}
				return result;
			},

			costOfTypeAction (types, actions) {
				let result = 0;
				for (const action of actions) {
					result += this.costOfType(types, action.costs);
				}
				return result;
			},

			costOfType (types, costs) {
				let result = 0;
				for (const cost of costs) {
					for (const division of cost.costDivisions) {
						if (types.indexOf(division.type) !== -1) {
							result += division.totalPrice;
						}
					}
				}
				return result;
			},

			generateExport () {
				return FinalReportInvoicesExporter.generate(this);
			},
		},

		props: {
			invoices: {},
			showInvoicesWarning: {type: Boolean, default: false},
			donation: {default: null},
			projectStartDate: {default: null},
			projectEndDate: {default: null},
      terms: {default: {}},
		}
	};
</script>
<style>
	.final-report-invoices-header strong {
		font-size: 9px;
	}

	.final-report-invoices-header .v-card__text {
		padding: 5px 2px;
	}
</style>